// extracted by mini-css-extract-plugin
module.exports = {"treeCard":"TreeCard_treeCard__3U2LM","wrapper":"TreeCard_wrapper__3sM1e","title":"TreeCard_title__1YLdD","text":"TreeCard_text__19xRq"};